import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense, useState } from "react";
import { HelmetProvider } from "react-helmet-async";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import LoadingScreen from "./components/LoadingScreen";
import CookieConsent from "./components/CookieConsent";
import ScrollToTopButton from "./components/ScrollToTopButton";
import WhatsAppButton from "./components/WhatsAppButton";
import ComingSoon from "./components/ComingSoon";
import "./App.css";

// Lazy load pages for performance
const Home = lazy(() => import("./pages/Home"));
const Menu = lazy(() => import("./pages/Menu"));
const OrderOnline = lazy(() => import("./pages/OrderOnline"));
const Reserve = lazy(() => import("./pages/Reserve"));
const Vouchers = lazy(() => import("./pages/Vouchers"));
const About = lazy(() => import("./pages/About"));
const Gallery = lazy(() => import("./pages/Gallery"));
const Contact = lazy(() => import("./pages/Contact"));
const Privacy = lazy(() => import("./pages/Privacy"));
const Terms = lazy(() => import("./pages/Terms"));
const NotFound = lazy(() => import("./pages/NotFound"));

// Loading spinner for page transitions
const PageLoader = () => (
  <div className="min-h-screen bg-[#0D0D0D] flex items-center justify-center">
    <div className="flex flex-col items-center gap-4">
      <div className="w-12 h-12 border-2 border-[#C9A84C] border-t-transparent rounded-full animate-spin" />
      <span className="text-[#C9A84C] font-serif text-lg">Loading...</span>
    </div>
  </div>
);

function App() {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <ComingSoon>
          {/* Initial Loading Screen */}
          <LoadingScreen onComplete={() => setIsLoaded(true)} />
         
          <ScrollToTop />
          {/* pt-[100px] = 36px announcement bar + 64px navbar */}
          <div className="min-h-screen bg-[#0D0D0D] text-[#F5F0E8] flex flex-col pt-[100px]">
            <Navbar />
            <main className="flex-grow">
              <Suspense fallback={<PageLoader />}>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/menu" element={<Menu />} />
                  <Route path="/order" element={<OrderOnline />} />
                  <Route path="/reserve" element={<Reserve />} />
                  <Route path="/vouchers" element={<Vouchers />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/gallery" element={<Gallery />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/terms" element={<Terms />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </Suspense>
            </main>
            <Footer />
          </div>
         
          {/* Global UI Components */}
          <WhatsAppButton />
          <ScrollToTopButton />
          <CookieConsent />
        </ComingSoon>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
